import React from "react"
import { useClickOutside } from "use-events"

import Logo from "./Logo"

const Navbar = () => {
  const hrefSymbol = "#"

  const [menu, setMenu] = React.useState(false)

  // Toggle menu open/close when clicking on mobile menu icon
  const toggleMenu = () => {
    setMenu(!menu)
  }

  const mobileMenuContainerRef = React.useRef(null)
  const mobileMenuListRef = React.useRef(null)

  // When menu is opened, click anywhere outside of
  // mobile menu icon or mobile menu list to close menu
  useClickOutside([mobileMenuContainerRef, mobileMenuListRef], () => {
    if (menu) setMenu(false)
  })

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-left">
          <Logo />
          <div className="navbar-left-links">
            <a href={hrefSymbol}>Get started</a>
            <a href={hrefSymbol} className="downloads">
              Downloads
            </a>
          </div>
        </div>

        <div className="navbar-right">
          <a href={hrefSymbol}>About</a>
          <a href={hrefSymbol}>Contact us</a>
        </div>

        <div
          className="mobile-menu-container"
          ref={mobileMenuContainerRef}
          onClick={toggleMenu}
        >
          <div className="mobile-menu-icon">
            <div className={menu ? "line-top-open" : "line-top"} />
            <div className={menu ? "line-mid-open" : "line-mid"} />
            <div className={menu ? "line-bottom-open" : "line-bottom"} />
          </div>

          <ul
            className={menu ? "mobile-menu-list-open" : "mobile-menu-list"}
            ref={mobileMenuListRef}
          >
            <a
              className={
                menu ? "mobile-menu-list-open-item" : "mobile-menu-list-item"
              }
              href={hrefSymbol}
            >
              Get started
            </a>
            <a
              className={
                menu ? "mobile-menu-list-open-item" : "mobile-menu-list-item"
              }
              href={hrefSymbol}
            >
              Downloads
            </a>
            <a
              className={
                menu ? "mobile-menu-list-open-item" : "mobile-menu-list-item"
              }
              href={hrefSymbol}
            >
              About
            </a>
            <a
              className={
                menu ? "mobile-menu-list-open-item" : "mobile-menu-list-item"
              }
              href={hrefSymbol}
            >
              Contact us
            </a>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
